import { render } from "./PreloadingScript.vue?vue&type=template&id=33774552&scoped=true"
import script from "./PreloadingScript.vue?vue&type=script&lang=js"
export * from "./PreloadingScript.vue?vue&type=script&lang=js"

import "./PreloadingScript.vue?vue&type=style&index=0&id=33774552&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33774552"],['__file',"src/components/mdbvue/pro/Components/PreloadingScript.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33774552"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33774552', __exports__)) {
    api.reload('33774552', __exports__)
  }
  
  module.hot.accept("./PreloadingScript.vue?vue&type=template&id=33774552&scoped=true", () => {
    api.rerender('33774552', render)
  })

}


export default __exports__